import React, { useState, useRef, useEffect } from 'react';
import styles from './CreateStudents.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import { useMutation } from 'react-query';
import axios from 'axios';
import userIcon from '../../../../assets/Imagess/userinputicon.svg';
import { API_URL, securityHeaders } from '../../../../Constants';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import { useFetchDropDownTypes } from '../../../../Hooks/Settings';
import ambassadorAdded from '../../../../assets/Imagess/ambassador-updated.png';
import { useFetchAmbassadorById } from '../../../../Hooks/Alumni';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextInput from '../../../Atoms/Inputs/TextInput';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import FlagsSelect from '../../../Atoms/Inputs/FlagsSelect';
import Loader from '../../../Molecules/Loader/Loader';

const UpdateAmbassador = () => {
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const formikRef = useRef(null);
  const navigate = useNavigate();
  const [showCheckmark, setShowCheckmark] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const { data: nationalities } = useFetchDropDownTypes(3);
  const { data: ambassador, isLoading, refetch } = useFetchAmbassadorById(id);
  const customizedToast = useToast();
  useEffect(() => {
    if (!isEmpty(id) && undefined !== id) {
      refetch();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(ambassador)) {
      const ambassadorData = ambassador.data[0];
      formikRef.current.setValues({
        name: ambassadorData.ambassadorName_EN || '',
        nameAr: ambassadorData.ambassadorName_AR || '',
        countryFlag: ambassadorData.countryFlag || '',
      });
      setImageSrc(
        `${ambassador?.data[0]?.url}${ambassador?.data[0]?.ambassadorImage}`
      );
    }
  }, [ambassador]);
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Ambassador name is required'),
    nameAr: Yup.string().required('Arabic ambassador name is required'),
    countryFlag: Yup.string().required('countryFlag is required'),
    image:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().required('Image is required'),
  });

  const createAmbassador = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Alumni/AlumniAmbassador`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: (data) => {
      customizedToast.open(
        id
          ? 'Ambassador is updated successfully'
          : 'Ambassador is created successfully'
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append('ambassadorName_EN', values.name);
    formData.append('ambassadorName_AR', values.nameAr);
    formData.append('CountryFlag', values.countryFlag);

    const ambassadorId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('alumniAmbassadorId', ambassadorId);
    if (undefined !== values.image) {
      formData.append('ambassadorImage', values.image);
    }
    createAmbassador.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={id ? 'Update Ambassador' : 'Add New Ambassador'}
        />
      </div>
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            name: ambassador?.data[0]?.ambassadorName_EN || '',
            nameAr: ambassador?.data[0]?.ambassadorName_AR || '',
            image: null,
            countryFlag: '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => {
            return (
              <Form>
                <div className={styles['steps']}>
                  <div className={styles['step-container']}>
                    <TextInput
                      label='Name'
                      placeholder='Enter Name'
                      icon={userIcon}
                      style={{
                        width: '100%',
                        justifyContent: 'flex-start',
                      }}
                      containerStyle={{ padding: '0px' }}
                      errors={errors.name}
                      touched={touched.name}
                      value={values.name}
                      name='name'
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                    />
                  </div>
                  <div
                    className={`${styles['step-container']} ${styles['rtl']}`}
                    style={{ display: 'block' }}
                  >
                    <TextInput
                      label='الاسم'
                      placeholder='أدخل الاسم'
                      icon={userIcon}
                      style={{
                        width: '100%',
                        justifyContent: 'flex-start',
                        marginBottom: '26px',
                      }}
                      containerStyle={{ padding: '0px' }}
                      name='nameAr'
                      value={values.nameAr}
                      errors={errors.nameAr}
                      touched={touched.nameAr}
                      onChange={(name, value) => setFieldValue(name, value)}
                    />
                  </div>
                  <div className={`${styles['step-container']}`}>
                    <FlagsSelect
                      name='countryFlag'
                      icon={folderIcon}
                      placeholder='Select a country'
                      label='Country'
                      value={values.countryFlag}
                      error={errors.countryFlag}
                      touched={touched.countryFlag}
                      onChange={(name, value) => setFieldValue(name, value)}
                    />
                  </div>
                </div>
                {errors.image && touched.image && (
                  <div className={styles['error-message']}>
                    <p>{errors.image}</p>
                  </div>
                )}
                <div style={{ marginTop: '30px' }}>
                  <label>رفع الصورة</label>
                </div>
                <div
                  className={styles['upload-container']}
                  style={{ marginTop: '30px' }}
                  onClick={() => fileInputRef.current.click()}
                >
                  <input
                    type='file'
                    className='form-control form-body-input'
                    accept='image/*'
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onChange={(event) =>
                      setFieldValue('image', event.currentTarget.files[0])
                    }
                  />
                  {values.image ? (
                    <img
                      className={styles['uploaded-image']}
                      src={URL.createObjectURL(values.image)}
                      alt='selected-image'
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                    />
                  ) : imageSrc ? (
                    <img
                      className={styles['uploaded-image']}
                      src={imageSrc}
                      alt='selected-image'
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                    />
                  ) : (
                    <div className={styles['upload-icon-container']}>
                      <img className={styles['upload-icon']} src={uploadIcon} />
                      <div className={styles['text-container']}>
                        <p className={styles['select-image']}>
                          Select Image to Upload
                        </p>
                        <p className={styles['size']}>max size: 100MB</p>
                      </div>
                    </div>
                  )}
                </div>

                <button
                  type='submit'
                  className={styles['submit-button']}
                  style={{ display: 'none' }}
                >
                  Submit
                </button>
              </Form>
            );
          }}
        </Formik>
      </div>
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={ambassadorAdded} />
        </div>
      )}
    </div>
  );
};

export default UpdateAmbassador;
